import { Box, Grid, Tooltip, Typography } from "@mui/material";
import React, { useContext, useEffect, useRef, useState } from "react";
import AnimatedButton from "../AnimatedButton/AnimatedButton";
// import CreditOptionButton from "../AnimatedButton/CreditOptionButton";
import rundownIcon from "../../assets/newRundown.svg";
import startIcon from "../../assets/newStart.svg";
import tradeIcon from "../../assets/newTrades.svg";
import rankingsIcon from "../../assets/newRankings.svg";
import newsIcon from "../../assets/newNews.svg";
import waiverIcon from "../../assets/newWaivers.svg";
import rostersIcon from "../../assets/newRosters.svg";
import DraftAdviceIcon from "../../assets/newDraft.svg";
import DraftAdviceIcon2 from "../../assets/newDraftAdvice2.png";
import DraftAdviceIcon3 from "../../assets/DraftAdvice3.svg";
// import ChatIcon from "@mui/icons-material/Chat";
import ChatIcon from "../../assets/newChatIcon.svg";
import GroupsIcon from "@mui/icons-material/Groups";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import { WidgetContext } from "src/contexts/WidgetContext";
import NewsPartnerList from "../News/NewsPartnerList";
import RankingsPartnerList from "../Rankings/RankingsPartnerList";
import TradingPartnerList from "../TradingPartner/TradingPartnerList";
import WaiverPartnerListStream from "../Waiver/WaiverPartnerListStream";
import RundownPartnerListStream from "../Rundown/RundownPartnerListStream";
import StartPartnerListStream from "../StartPlayers/StartPartnerListStream";
import { useAuth0 } from "@auth0/auth0-react";
import { audioService } from "src/services/audioService";
import { isAndroid, isMobileWebBrowser, mobile } from "src/utils/platformUtils";
import { redirectToAuth0NoCredits } from "src/utils/auth0NoCredits";
import RostersPartnerList from "../Rosters/RostersPartnerList";
import { useSafeAccessAuth0Token } from "src/hooks/useSafeAccessAuth0Token";
import ChatBotButton from "../ChatBot/ChatBotButton";
import VoiceChatIcon from "@mui/icons-material/VoiceChat";
import ChatBotList from "../ChatBot/ChatBotList";
import { primeMicrophoneOnce } from "src/utils/chatbotFunctions";
import { useFreeModelExecutionGate } from "src/hooks/useFreeModelExecutionGate";
import { trackEndpointAccess } from "src/utils/analyticsCapFirebase";
import DraftAdvicePartnerListStream from "../DraftAdvice/DraftAdvicePartnerListStream";
import { isDraftAdviceDisabledByLeagueStatus, isDraftAdviceDisabledForPlatform } from "src/utils/draftAdvicePlatformGate";
import AllRankingsPartnerList from "../AllRankings/AllRankingsPartnerList";
import ArticleIcon from "@mui/icons-material/Article";
import ArticlesPartnerList from "../Articles/ArticlesPartnerList";
import { isUnsyncedBlockedAgent, isUnsyncedPlatform } from "src/constants/unsyncedLeague";

const SectionHomePage = ({
  showPartnerList,
  selectedButton,
  handleButtonSelected,
  handlePartnerSelectAndCloseDrawer,
  handlePartnerSelectAndOpenDrawer,
  selectedPartner,
  hasLoadingStarted,
  userDataPlatform,
  leagueIdPlatform,
  loadingRundown,
  loadingDraftAdvice,
  loadingStart,
  loadingRoster,
  loadingNews,
  loadingRankings,
  loadingAllRankings,
  loadingWaiver,
  rundownData,
  DraftAdviceData,
  startData,
  rostersData,
  newsData,
  rankingsData,
  allRankingsData,
  waiverData,
  setLoadingRundown,
  setLoadingDraftAdvice,
  setLoadingStart,
  setLoadingRoster,
  setLoadingNews,
  setLoadingRankings,
  setLoadingAllRankings,
  setLoadingWaiver,
  fetchRundownDataStream,
  fetchDraftAdviceDataStream,
  fetchStartDataStream,
  fetchRostersData,
  fetchNewsData,
  fetchRankingsData,
  fetchAllRankingsData,
  fetchWaiverData,
  fetchWaiverDataStream,
  endpointErrors,
  setEndpointErrors,
  errorMessages,
  selectedTeamInfo,
  yahooToken,
  setErrorMessages,
  commonLeagueDataFailed,
  setCommonLeagueDataFailed,
  returnedFromBackground,
  setReturnedFromBackground,
  setShouldPlayAudio,
  waiverStreamState,
  hasWaiverAnimationCompleted,
  startStreamState,
  hasStartAnimationCompleted,
  rundownStreamState,
  hasRundownAnimationCompleted,
  setHasRundownAnimationCompleted,
  DraftAdviceStreamState,
  hasDraftAdviceAnimationCompleted,
  setHasDraftAdviceAnimationCompleted,
  setDraftAdviceData,
  setDraftAdviceStreamState,
  setHasStartAnimationCompleted,
  setHasWaiverAnimationCompleted,
  streamProgress,
  setStreamProgress,
  summaryAudios,
  // isRundownAudioPlaying,
  // onToggleRundownAudio,
  summaryAudioRefs,
  streamProgressTargets,
  errorMessageNoDraft,
  isRecoveringFromBackground,
  activeStreamRequests,
  aiSettings,
  setIsSuperAnalysisComplete,
  isSuperAnalysisComplete,
  setHasLoadingStarted,
  forceRefresh,
  setWaiverData,
  setStartData,
  setRundownData,
  setWaiverStreamState,
  setStartStreamState,
  setRundownStreamState,
  setSummaryAudios,
  setThoughtsCommon,
  markSignThoughtsForDrawer,
  clearSignThoughtsDrawerSource,
  hasAudioBeenPlayed,
  activeRequests,
  estimatedTimes,
  credits,
  setIsPaymentOpen,
  setInitialPaymentView,
  setIsBenchDrawerOpen,
  enableCreditValidation,
  getCreditsBoxPosition,
  calculatorSettings,
  leagueSettingsChanged,
  setLeagueSettingsChanged,
  selectedModel,
  setSelectedModel,
  userSubscription,
  setUserSubscription,
  setStreamProgressTargets,
  characterRef,
  updateCreditsAfterEndpoint,
  isCreditsAnimating,
  creditsBoxRef,
  leagueSelectorBoxRef,
}) => {
  const {
    setCurrentAbortController,
    cancelPendingRequests,
    getValidYahooToken,
    userDataCache,
    leaguePlatforms,
    sectionData,
    isLoggedInAuth0ExperienceGlobal,
    NON_LOGGED_IN_CONFIG,
    freeCredits,
    allowedButtonsSections,
    updateButtonProgress,
    isIdpLeagueBlocked,
  } = useContext(WidgetContext);
  const { user, loginWithRedirect } = useAuth0();
  // Use global state to determine which authId to use
  const authId = isLoggedInAuth0ExperienceGlobal ? user?.sub : NON_LOGGED_IN_CONFIG.NON_LOGGED_IN_AUTH_ID;
  const { getSafeAccessAuth0Token } = useSafeAccessAuth0Token();
  const { gate: gateFreeModelExecution, GateDrawer: FreeModelGateDrawer } = useFreeModelExecutionGate();
  // Full-screen LoaderFacts in Draft Advice drawer only while a forced refresh (footer) is in flight
  const [showDraftAdviceFooterLoader, setShowDraftAdviceFooterLoader] = useState(false);
  //useffect to set the showDraftAdviceFooterLoader to false when the loadingDraftAdvice is false
  useEffect(() => {
    if (!loadingDraftAdvice) {
      setShowDraftAdviceFooterLoader(false);
    }
  }, [loadingDraftAdvice]);
  // Ref to track if the audio has been unlocked
  const audioUnlockedRef = useRef(false);
  const noDraftErrorMessage = "Rosters are empty as this league has not had it's draft yet. Try a different league.";

  // Helper function to unlock audio on the first relevant user interaction.
  const handleUnlockAudio = () => {
    // This logic will now ONLY run on mobile web browsers.
    // Capacitor Android also needs the gesture unlock; Capacitor iOS does not (plays the passed element).
    const mobileWeb = isMobileWebBrowser();
    const capacitorAndroid = mobile && isAndroid;
    if ((mobileWeb || capacitorAndroid) && !audioUnlockedRef.current) {
      audioService.unlockAudio();
      audioUnlockedRef.current = true;
    }
  };

  // Subscription-based model selection (matching Super Analysis behavior):
  // - If subscription is "free" => use FREE model for waiver/start/rundown/DraftAdvice
  // - Otherwise => use premium model directly
  // Default to "free" if subscription is missing to avoid accidentally using premium in unknown states.
  const subscriptionIsFree = (userSubscription || "free").toLowerCase() === "free";
  const subscriptionModel: "RotoGPT 5.0" | "RotoGPT FREE" = subscriptionIsFree ? "RotoGPT FREE" : "RotoGPT 5.0";

  const showChatBot = allowedButtonsSections?.showChatBot ?? true;
  const showNews = allowedButtonsSections?.showNews ?? true;
  const showAllRankings = allowedButtonsSections?.showAllRankings ?? true;
  const showRosters = allowedButtonsSections?.showRosters ?? true;
  const showTrades = allowedButtonsSections?.showTrades ?? true;
  const showTeamAnalysis = allowedButtonsSections?.showTeamAnalysis ?? true;
  const showStart = allowedButtonsSections?.showStart ?? true;
  const showWaiver = allowedButtonsSections?.showWaiver ?? true;
  const showDraftAdvice = allowedButtonsSections?.showDraftAdvice ?? true;
  const disabledPlatformDraftAdvice = allowedButtonsSections?.disabledPlatformDraftAdvice ?? [];
  const isDraftAdviceDisabledForCurrentPlatform = isDraftAdviceDisabledForPlatform(
    selectedTeamInfo?.platformId,
    disabledPlatformDraftAdvice
  );
  // Draft Advice endpoint is enabled when the showDraftAdvice button is enabled and the platform is not disabled (isDraftAdviceDisabledForPlatform logic)
  const draftAdviceEndpointEnabled = showDraftAdvice && !isDraftAdviceDisabledForCurrentPlatform;
  const showArticles = allowedButtonsSections?.showArticles ?? true;

  // Un-Synced: blocked agents show "Sync A League" (list in unsyncedLeague.ts — remove label to enable later)
  const requiresSyncedLeagueFor = (label: string) =>
    isUnsyncedPlatform(selectedTeamInfo?.platformId) && isUnsyncedBlockedAgent(label);
  // Un-Synced: check if the selected team is unsynced
  const isUnsyncedSelected = isUnsyncedPlatform(selectedTeamInfo?.platformId);

  // Ref to track previous team for cleanup
  const previousTeamInfoRef = useRef<{ platformId?: string; leagueId?: string; teamName?: string } | null>(null);

  // // CRITICAL: Clean up waiver, rundown, DraftAdvice, and start when team changes
  useEffect(() => {
    if (previousTeamInfoRef.current !== null && selectedTeamInfo) {
      const currentTeamKey = `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
      const previousTeamKey = previousTeamInfoRef.current ? `${previousTeamInfoRef.current.platformId}-${previousTeamInfoRef.current.leagueId}` : null;

      // console.log("sectionHomePage: currentTeamKey", currentTeamKey);
      // console.log("sectionHomePage: selectedTeamInfo", selectedTeamInfo);
      // console.log("sectionHomePage: previousTeamInfo", previousTeamInfoRef.current);
      // console.log("sectionHomePage: previousTeamKey", previousTeamKey);
      // Only clean if team actually changed
      if (previousTeamKey !== null && currentTeamKey !== previousTeamKey) {
        const prevPlatformId = previousTeamInfoRef.current.platformId;
        const prevLeagueId = previousTeamInfoRef.current.leagueId;

        // Remove all request keys for the previous team
        const keysToRemove: string[] = [];
        if (activeStreamRequests?.current && authId) {
          activeStreamRequests.current.forEach((key) => {
            if (
              key === `${authId}-waiver-${prevPlatformId}-${prevLeagueId}` ||
              key === `${authId}-rundown-${prevPlatformId}-${prevLeagueId}` ||
              key === `${authId}-DraftAdvice-${prevPlatformId}-${prevLeagueId}` ||
              key === `${authId}-start-${prevPlatformId}-${prevLeagueId}`
            ) {
              keysToRemove.push(key);
            }
          });

          keysToRemove.forEach((key) => {
            activeStreamRequests.current.delete(key);
            console.log(`🗑️ Removed stale request key from previous team: ${key}`);
          });
        }

        // CRITICAL: Do NOT clear section data here - keep cache intact
        // This allows cached data to be used for immediate drawer opening on first click
        // setWaiverData({ waiver_analysis: "", chart_data: [], request_id: null });
        // setStartData({ start_analysis: "", chart_data: [], request_id: null });
        // setRundownData({ rundown_analysis: "", chart_data: [], request_id: null });

        // Only reset stream states and loading flags
        setWaiverStreamState({
          status: "",
          thought: "",
          isGeneratingResult: false,
          isStreamActive: false,
          isWaitingForChart: false,
          isGeneratingAudio: false,
          teamKey: null,
        });
        setStartStreamState({
          status: "",
          thought: "",
          isGeneratingResult: false,
          isStreamActive: false,
          isWaitingForChart: false,
          isGeneratingAudio: false,
          teamKey: null,
        });
        setRundownStreamState({
          status: "",
          thought: "",
          isGeneratingResult: false,
          isStreamActive: false,
          isWaitingForChart: false,
          isGeneratingAudio: false,
          teamKey: null,
        });
        setDraftAdviceStreamState({
          status: "",
          thought: "",
          isGeneratingResult: false,
          isStreamActive: false,
          isWaitingForChart: false,
          isGeneratingAudio: false,
          teamKey: null,
        });

        if (setSummaryAudios) {
          setSummaryAudios({
            rundown: null,
            DraftAdvice: null,
            waiver: null,
            start: null,
          });
        }
        if (hasAudioBeenPlayed) {
          hasAudioBeenPlayed.current = {
            rundown: false,
            DraftAdvice: false,
            waiver: false,
            start: false,
          };
        }

        // CRITICAL: Ensure loading states are false when team changes
        // This prevents the button animation from starting automatically
        setLoadingWaiver(false);
        setLoadingStart(false);
        setLoadingRundown(false);
        setLoadingDraftAdvice(false);

        // Clear stale thoughts instantly
        if (setThoughtsCommon) setThoughtsCommon("");
        if (clearSignThoughtsDrawerSource) clearSignThoughtsDrawerSource();

        // Reset Draft Advice progress/animation for the previous team so loaders and Run All Agents do not inherit ESPN/redraft state.
        setStreamProgressTargets((prev) => ({ ...prev, DraftAdvice: 0 }));
        if (authId && prevPlatformId && prevLeagueId) {
          updateButtonProgress(`${authId}-${prevPlatformId}-${prevLeagueId}-draft advice`, 0);
        }
        setHasDraftAdviceAnimationCompleted(false);
      }
    }

    // Update ref to track current team
    previousTeamInfoRef.current = selectedTeamInfo
      ? {
        platformId: selectedTeamInfo.platformId,
        leagueId: selectedTeamInfo.leagueId,
        teamName: selectedTeamInfo.teamName,
      }
      : null;
  }, [
    selectedTeamInfo,
    activeStreamRequests,
    authId,
    setLoadingWaiver,
    setLoadingStart,
    setLoadingRundown,
    setLoadingDraftAdvice,
    setStreamProgressTargets,
    updateButtonProgress,
    setHasDraftAdviceAnimationCompleted,
    setWaiverData,
    setStartData,
    setRundownData,
    setDraftAdviceData,
    setWaiverStreamState,
    setStartStreamState,
    setRundownStreamState,
    setDraftAdviceStreamState,
    setSummaryAudios,
    hasAudioBeenPlayed,
  ]);

  // Check if the data is valid for display
  // Also checks sectionData if local data is not available (for post-refresh scenarios)
  // const isDataValidForDisplay = (data: any, sectionKey?: "waiver" | "rundown" | "start") => {
  //   // First check local data
  //   if (data && data.context) {
  //     const isValid = data.context.platformId === selectedTeamInfo?.platformId && data.context.leagueId === selectedTeamInfo?.leagueId && data.context.userId === authId;
  //     if (isValid) return true;
  //   }

  //   // If local data is not valid/null, check sectionData (for post-refresh scenarios)
  //   if (sectionKey && sectionData && sectionData[sectionKey]) {
  //     const cachedData = sectionData[sectionKey];
  //     if (cachedData && cachedData.context) {
  //       return cachedData.context.platformId === selectedTeamInfo?.platformId && cachedData.context.leagueId === selectedTeamInfo?.leagueId && cachedData.context.userId === authId;
  //     }
  //   }

  //   return false;
  // };

  // Check if the data is valid for display
  const isDataValidForDisplay = (data: any) => {
    if (!data || !data.context) {
      return false;
    }
    return data.context.platformId === selectedTeamInfo?.platformId && data.context.leagueId === selectedTeamInfo?.leagueId && data.context.userId === authId;
  };

  // Helper function to detect if polling is active for a specific section
  // Polling is active when: loading is true, teamKey matches current team, and stream is NOT active
  const isPollingActive = (section: "waiver" | "start" | "rundown" | "DraftAdvice") => {
    if (!selectedTeamInfo) return false;
    const currentTeamKey = `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;

    if (section === "waiver") {
      return loadingWaiver && waiverStreamState?.teamKey === currentTeamKey && !waiverStreamState?.isStreamActive;
    } else if (section === "start") {
      return loadingStart && startStreamState?.teamKey === currentTeamKey && !startStreamState?.isStreamActive;
    } else if (section === "rundown") {
      return loadingRundown && rundownStreamState?.teamKey === currentTeamKey && !rundownStreamState?.isStreamActive;
    } else if (section === "DraftAdvice") {
      return loadingDraftAdvice && DraftAdviceStreamState?.teamKey === currentTeamKey && !DraftAdviceStreamState?.isStreamActive;
    }
    return false;
  };

  // CRITICAL: Detect polling state for each section to disable manualProgressTarget during polling
  // This allows time-based animation to run smoothly during polling instead of being stuck at a fixed value
  const isWaiverPolling = isPollingActive("waiver");
  const isStartPolling = isPollingActive("start");
  const isRundownPolling = isPollingActive("rundown");
  const isDraftAdvicePolling = isPollingActive("DraftAdvice");

  // Startup value comes from common league data: user can use Chat + Draft Advice; other grid buttons are disabled.
  const startUpContent = sectionData?.commonLeagueData?.league_info?.settings?.startup_rookie;
  const draftOrderSet = sectionData?.commonLeagueData?.league_info?.settings?.draft_order_set;
  const userHasDraftedPlayers = sectionData?.commonLeagueData?.league_info?.user_has_drafted_players;
  // When true, AnimatedButton lets Rosters and Trades bypass startup_rookie grid lock (same normalization as startup_rookie).
  //Normalize the values to boolean
  const isStartupMode = startUpContent === true || startUpContent === "true" || startUpContent === "1" || startUpContent === 1;
  const isDraftOrderSet = draftOrderSet === true || draftOrderSet === "true" || draftOrderSet === "1" || draftOrderSet === 1;
  const isUserHasDraftedPlayers = userHasDraftedPlayers === true || userHasDraftedPlayers === "true" || userHasDraftedPlayers === "1" || userHasDraftedPlayers === 1;
  // Only block Draft Advice when the API sends draft_order_set explicitly as false/0. Missing (undefined/null) => do not block (treat as enabled for this rule).
  const draftOrderSetPresent = draftOrderSet !== undefined && draftOrderSet !== null;
  const isDraftOrderSetExplicitlyFalse =
    draftOrderSetPresent &&
    !isDraftOrderSet &&
    (draftOrderSet === false ||
      draftOrderSet === 0 ||
      draftOrderSet === "0" ||
      (typeof draftOrderSet === "string" && draftOrderSet.trim().toLowerCase() === "false"));
  // Like startup_rookie: draft_order_set is only meaningful once common league data exists for the selected team (avoids disabling Draft Advice while commonLeagueData is still null during stream).
  const commonLeagueForDraftGate = sectionData?.commonLeagueData;
  const commonLeagueDataReadyForDraftOrder =
    !!commonLeagueForDraftGate?.league_info &&
    !!selectedTeamInfo &&
    commonLeagueForDraftGate.platform === selectedTeamInfo.platformId &&
    commonLeagueForDraftGate.leagueId === selectedTeamInfo.leagueId &&
    commonLeagueForDraftGate.teamName === selectedTeamInfo.teamName;

  // Redraft league type: only Draft Advice is disabled (other buttons behave normally). Match API casing/whitespace.
  const leagueTypeContent = sectionData?.commonLeagueData?.league_info?.league_type;
  const isLeagueTypeRedraft = typeof leagueTypeContent === "string" && leagueTypeContent.trim().toLowerCase() === "redraft";
  // League status: drives per-scenario button label messages. Normalized to lowercase for safe comparisons.
  const leagueStatus = typeof sectionData?.commonLeagueData?.league_info?.league_status === 'string'
    ? sectionData.commonLeagueData.league_info.league_status.trim().toLowerCase()
    : '';
  // Draft Advice Coming Soon for pre_draft/drafting (only after common data matches selected team).
  const draftAdviceEnabledForSelectedLeague =
    draftAdviceEndpointEnabled &&
    !(commonLeagueDataReadyForDraftOrder && isDraftAdviceDisabledByLeagueStatus(leagueStatus));

  useEffect(() => {
    console.log('startup/league type logs:startUpContent', startUpContent);
    console.log('startup/league type logs:isStartupMode', isStartupMode);
    console.log('startup/league type logs:draftOrderSet', draftOrderSet);
    console.log('startup/league type logs:isDraftOrderSet', isDraftOrderSet);
    console.log('startup/league type logs:isDraftOrderSetExplicitlyFalse', isDraftOrderSetExplicitlyFalse);
    console.log('startup/league type logs:userHasDraftedPlayers', userHasDraftedPlayers);
    console.log('startup/league type logs:isUserHasDraftedPlayers', isUserHasDraftedPlayers);
    console.log('startup/league type logs:leagueTypeContent', leagueTypeContent);
    console.log('startup/league type logs:isLeagueTypeRedraft', isLeagueTypeRedraft);
    console.log('startup/league type logs:draftAdviceEnabledForSelectedLeague', draftAdviceEnabledForSelectedLeague);
  }, [startUpContent, leagueTypeContent, draftOrderSet, isDraftOrderSetExplicitlyFalse, isUserHasDraftedPlayers]);
  // NEW: team key used to force remount of manual buttons per team

  // Click handler for Waiver Button
  const handleWaiverButtonClick = async () => {
    if (!showWaiver) return;
    // Subscription-based model selection (matches Super Analysis approach)
    const modelToUse = subscriptionModel;

    // Check if user has credits
    // DEV: Comment enableCreditValidation prop in HomePage to disable this check
    // Only open paywall if user has 0 credits AND no valid cached data
    const hasValidData = isDataValidForDisplay(waiverData);

    // Check freeCredits ONLY if there's no valid data to show (for FREE model users)
    // If there's valid data, allow viewing it even if freeCredits === 0 (user already paid for it)
    if (!hasValidData && userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      console.log("[Waiver] Opening BenchDrawer: No freeCredits available and no valid data to show");
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return; // Exit early, don't start any flow
    }
    // IMPORTANT: Open paywall for premium subscriptions (non-free) with 0 credits.
    // Free subscriptions will use FREE model (with ads), so they don't need paywall here.
    if (enableCreditValidation && credits <= 9 && !hasValidData && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    console.log("forceRefresh in handleWaiverButtonClick:", forceRefresh);
    console.log("Using model for waiver:", modelToUse);
    handleUnlockAudio();
    handleButtonSelected("waiver");

    // CRITICAL: Only open drawer if data is valid for CURRENT team
    // const hasValidData = isDataValidForDisplay(waiverData);
    const isStreamForCurrentTeam = waiverStreamState?.teamKey === (selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : null);
    const hasValidStream = waiverStreamState?.isGeneratingResult && isStreamForCurrentTeam;

    if (hasValidData || hasValidStream) {
      handlePartnerSelectAndOpenDrawer(selectedPartner);
      return;
    }

    // if (!isSuperAnalysisComplete && hasLoadingStarted && !commonLeagueDataFailed) {
    //   console.log("Waivers analysis is not ready yet.");
    //   return;
    // }

    // If data is not valid or not available, fetch it on demand
    if (!hasValidData && selectedTeamInfo && !loadingWaiver) {
      // 
      if (setThoughtsCommon) {
        setThoughtsCommon("Loading...");
      }
      const execute = async () => {
        const { platformId, leagueId, teamName } = selectedTeamInfo;
        const currentUserDataPlatform = userDataCache[platformId];

        // Get valid token if needed (for Yahoo)
        let validToken = currentUserDataPlatform?.token;
        if (currentUserDataPlatform?.integration_name === "yahoo") {
          try {
            const yahooTokenRefreshed = await getValidYahooToken();
            if (yahooTokenRefreshed) {
              validToken = yahooTokenRefreshed;
            } else {
              console.error("Failed to get valid Yahoo token for waiver");
              return;
            }
          } catch (error) {
            console.error("Error getting valid Yahoo token for waiver:", error);
            return;
          }
        }

        // Create new controller and register it
        const controller = new AbortController();
        setCurrentAbortController(controller);
        setLoadingWaiver(true);
        setEndpointErrors((prev) => ({ ...prev, [`waiver-${platformId}-${leagueId}`]: false }));

        // Execute the endpoint with error handling
        fetchWaiverDataStream(leagueId, platformId, teamName, controller.signal, validToken, forceRefresh, calculatorSettings, modelToUse).catch((error) => {
          if (error.name === "AbortError") throw error;
          if (!returnedFromBackground) {
            const errorMessage = error?.message || "";
            setErrorMessages((prev) => ({ ...prev, Waiver: errorMessage }));
            if (errorMessage.trim() !== noDraftErrorMessage) {
              const errorKey = `waiver-${platformId}-${leagueId}`;
              setEndpointErrors((prev) => ({ ...prev, [errorKey]: true }));
            }
          }
        });
      };

      if (modelToUse === "RotoGPT FREE") {
        // CRITICAL: Reset progress to 0 BEFORE showing ad
        // This prevents the loader from jumping to 100% when ad closes
        setStreamProgressTargets((prev) => ({ ...prev, waiver: 0 }));
        // Execute after ad completes (web drawer / native AdMob)
        void gateFreeModelExecution(() => void execute());
        return;
      }

      await execute();
    }
  };

  // Click handler for Rundown Button
  const handleRundownButtonClick = async () => {
    if (!showTeamAnalysis) return;
    // Subscription-based model selection (matches Super Analysis approach)
    const modelToUse = subscriptionModel;

    // Check if user has credits
    // DEV: Comment enableCreditValidation prop in HomePage to disable this check
    // Only open paywall if user has 0 credits AND no valid cached data
    const hasValidData = isDataValidForDisplay(rundownData);

    // Check freeCredits ONLY if there's no valid data to show (for FREE model users)
    // If there's valid data, allow viewing it even if freeCredits === 0 (user already paid for it)
    if (!hasValidData && userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      console.log("[Rundown] Opening BenchDrawer: No freeCredits available and no valid data to show");
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return; // Exit early, don't start any flow
    }
    // IMPORTANT: Open paywall for premium subscriptions (non-free) with 0 credits.
    // Free subscriptions will use FREE model (with ads), so they don't need paywall here.
    if (enableCreditValidation && credits <= 9 && !hasValidData && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    console.log("Using model for rundown:", modelToUse);
    handleUnlockAudio(); // Unlock audio on this user interaction
    handleButtonSelected("rundown");

    // CRITICAL: Only open drawer if data is valid for CURRENT team
    // const hasValidData = isDataValidForDisplay(rundownData);
    const isStreamForCurrentTeam = rundownStreamState?.teamKey === (selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : null);
    const hasValidStream = rundownStreamState?.isGeneratingResult && isStreamForCurrentTeam;

    if (hasValidData || hasValidStream) {
      handlePartnerSelectAndOpenDrawer(selectedPartner);
      return;
    }

    // if (!isSuperAnalysisComplete && hasLoadingStarted && !commonLeagueDataFailed) {
    //   console.log("Rundown analysis is not ready yet.");
    //   return;
    // }

    // If data is not valid or not available, fetch it on demand
    if (!hasValidData && selectedTeamInfo && !loadingRundown) {
      if (setThoughtsCommon) {
        setThoughtsCommon("Loading...");
      }
      const execute = async () => {
        const { platformId, leagueId, teamName } = selectedTeamInfo;
        const currentUserDataPlatform = userDataCache[platformId];

        // Get valid token if needed (for Yahoo)
        let validToken = currentUserDataPlatform?.token;
        if (currentUserDataPlatform?.integration_name === "yahoo") {
          try {
            const yahooTokenRefreshed = await getValidYahooToken();
            if (yahooTokenRefreshed) {
              validToken = yahooTokenRefreshed;
            } else {
              console.error("Failed to get valid Yahoo token for rundown");
              return;
            }
          } catch (error) {
            console.error("Error getting valid Yahoo token for rundown:", error);
            return;
          }
        }

        // Cancel any pending requests
        // cancelPendingRequests();

        // Create new controller and register it
        const controller = new AbortController();
        setCurrentAbortController(controller);
        setLoadingRundown(true);
        setEndpointErrors((prev) => ({ ...prev, [`rundown-${platformId}-${leagueId}`]: false }));

        // Execute the endpoint with error handling (matching TeamsDropdown.tsx pattern)
        fetchRundownDataStream(leagueId, platformId, teamName, controller.signal, validToken, forceRefresh, calculatorSettings, modelToUse).catch((error) => {
          if (error.name === "AbortError") throw error;
          if (!returnedFromBackground) {
            const errorMessage = error?.message || "";
            setErrorMessages((prev) => ({ ...prev, Rundown: errorMessage }));
            if (errorMessage.trim() !== noDraftErrorMessage) {
              const errorKey = `rundown-${platformId}-${leagueId}`;
              setEndpointErrors((prev) => ({ ...prev, [errorKey]: true }));
            }
          }
        });
      };

      if (modelToUse === "RotoGPT FREE") {
        // CRITICAL: Reset progress to 0 BEFORE showing ad
        // This prevents the loader from jumping to 100% when ad closes
        setStreamProgressTargets((prev) => ({ ...prev, rundown: 0 }));
        void gateFreeModelExecution(() => void execute());
        return;
      }

      await execute();
    }
  };

  // Click handler for Draft Advice (Draft Advice) Button
  const handleDraftAdviceButtonClick = async () => {
    if (!draftAdviceEnabledForSelectedLeague) return;
    const modelToUse = subscriptionModel;
    const hasValidData = isDataValidForDisplay(DraftAdviceData);

    if (!hasValidData && userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      console.log("[Draft Advice] Opening BenchDrawer: No freeCredits available and no valid data to show");
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }
    if (enableCreditValidation && credits <= 9 && !hasValidData && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    handleUnlockAudio();
    handleButtonSelected("DraftAdvice");

    const isStreamForCurrentTeam = DraftAdviceStreamState?.teamKey === (selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : null);
    const hasValidStream = DraftAdviceStreamState?.isGeneratingResult && isStreamForCurrentTeam;

    if (hasValidData || hasValidStream) {
      handlePartnerSelectAndOpenDrawer(selectedPartner);
      return;
    }

    if (!hasValidData && selectedTeamInfo && !loadingDraftAdvice) {
      if (setThoughtsCommon) {
        setThoughtsCommon("Loading...");
      }
      const execute = async () => {
        const { platformId, leagueId, teamName } = selectedTeamInfo;
        const currentUserDataPlatform = userDataCache[platformId];
        let validToken = currentUserDataPlatform?.token;
        if (currentUserDataPlatform?.integration_name === "yahoo") {
          try {
            const yahooTokenRefreshed = await getValidYahooToken();
            if (yahooTokenRefreshed) validToken = yahooTokenRefreshed;
            else {
              console.error("Failed to get valid Yahoo token for draft advice");
              return;
            }
          } catch (error) {
            console.error("Error getting valid Yahoo token for draft advice:", error);
            return;
          }
        }
        const controller = new AbortController();
        setCurrentAbortController(controller);
        setLoadingDraftAdvice(true);
        setEndpointErrors((prev) => ({ ...prev, [`DraftAdvice-${platformId}-${leagueId}`]: false }));
        // setStreamProgressTargets((prev) => ({ ...prev, DraftAdvice: 0 }));

        fetchDraftAdviceDataStream(leagueId, platformId, teamName, controller.signal, validToken, forceRefresh, calculatorSettings, modelToUse).catch((error) => {
          if (error.name === "AbortError") throw error;
          if (!returnedFromBackground) {
            const errorMessage = error?.message || "";
            setErrorMessages((prev) => ({ ...prev, DraftAdvice: errorMessage }));
            if (errorMessage.trim() !== noDraftErrorMessage) {
              setEndpointErrors((prev) => ({ ...prev, [`DraftAdvice-${platformId}-${leagueId}`]: true }));
            }
          }
        });
      };

      if (modelToUse === "RotoGPT FREE") {
        setStreamProgressTargets((prev) => ({ ...prev, DraftAdvice: 0 }));
        void gateFreeModelExecution(() => void execute());
        return;
      }
      await execute();
    }
  };

  // function to handle forced refresh of draft advice
  const handleDraftAdviceForcedRefresh = async () => {
    // guard clause to check if the draft advice is enabled and the team is selected and the loading draft advice is false
    if (!draftAdviceEnabledForSelectedLeague || !selectedTeamInfo || loadingDraftAdvice) return;

    const modelToUse = subscriptionModel;

    // if the user is a free user and the model is RotoGPT FREE and the free credits are less than 9, then open the bench drawer
    if (userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    // if the user is a premium user and the model is RotoGPT 5.0 and the credits are less than 9, then open the paywall
    if (enableCreditValidation && credits <= 9 && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    // execute the forced refresh of the draft advice
    const execute = async () => {
      const { platformId, leagueId, teamName } = selectedTeamInfo;
      const currentUserDataPlatform = userDataCache[platformId];
      let validToken = currentUserDataPlatform?.token;

      if (currentUserDataPlatform?.integration_name === "yahoo") {
        try {
          const yahooTokenRefreshed = await getValidYahooToken();
          if (yahooTokenRefreshed) validToken = yahooTokenRefreshed;
          else return;
        } catch (error) {
          console.error("Error getting valid Yahoo token for draft advice forced refresh:", error);
          return;
        }
      }

      cancelPendingRequests(); // cancel any pending requests
      const requestKey = `${authId}-DraftAdvice-${platformId}-${leagueId}`;
      activeStreamRequests.current.delete(requestKey); // delete the request key

      const controller = new AbortController(); // create a new abort controller
      setCurrentAbortController(controller); // set the current abort controller
      setShowDraftAdviceFooterLoader(true); // Drawer stays open; LoaderFacts while this forced refresh runs
      setLoadingDraftAdvice(true); // set the loading draft advice to true
      setEndpointErrors((prev) => ({ ...prev, [`DraftAdvice-${platformId}-${leagueId}`]: false })); // set the endpoint errors to false

      // fetch the draft advice data stream (new request)
      fetchDraftAdviceDataStream(leagueId, platformId, teamName, controller.signal, validToken, true, calculatorSettings, modelToUse).catch((error) => { // fetch the draft advice data stream
        if (error.name === "AbortError") throw error;
        if (!returnedFromBackground) {
          const errorMessage = error?.message || "";
          setErrorMessages((prev) => ({ ...prev, DraftAdvice: errorMessage }));
          if (errorMessage.trim() !== noDraftErrorMessage) {
            setEndpointErrors((prev) => ({ ...prev, [`DraftAdvice-${platformId}-${leagueId}`]: true }));
          }
        }
      });
    };

    if (modelToUse === "RotoGPT FREE") {
      setStreamProgressTargets((prev) => ({ ...prev, DraftAdvice: 0 }));
      void gateFreeModelExecution(() => void execute());
      return;
    }

    await execute();
  };

  // Click handler for Start Button
  const handleStartButtonClick = async () => {
    if (!showStart) return;
    // Subscription-based model selection (matches Super Analysis approach)
    const modelToUse = subscriptionModel;

    // Check if user has credits
    // DEV: Comment enableCreditValidation prop in HomePage to disable this check
    // Only open paywall if user has 0 credits AND no valid cached data
    const hasValidData = isDataValidForDisplay(startData);

    // Check freeCredits ONLY if there's no valid data to show (for FREE model users)
    // If there's valid data, allow viewing it even if freeCredits === 0 (user already paid for it)
    if (!hasValidData && userSubscription === "free" && modelToUse === "RotoGPT FREE" && freeCredits <= 9) {
      console.log("[Start] Opening BenchDrawer: No freeCredits available and no valid data to show");
      // Non-logged out of credits: redirect to Auth0 (no-credits message) instead of BenchDrawer
      if (!isLoggedInAuth0ExperienceGlobal) {
        await redirectToAuth0NoCredits(loginWithRedirect);
        return;
      }
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return; // Exit early, don't start any flow
    }
    // IMPORTANT: Open paywall for premium subscriptions (non-free) with 0 credits.
    // Free subscriptions will use FREE model (with ads), so they don't need paywall here.
    if (enableCreditValidation && credits <= 9 && !hasValidData && modelToUse === "RotoGPT 5.0" && !subscriptionIsFree) {
      setInitialPaymentView("manageMembership");
      setIsPaymentOpen(true);
      return;
    }

    console.log("Using model for start:", modelToUse);
    handleUnlockAudio(); // Unlock audio on this user interaction
    handleButtonSelected("start");

    // CRITICAL: Only open drawer if data is valid for CURRENT team
    // const hasValidData = isDataValidForDisplay(startData);
    const isStreamForCurrentTeam = startStreamState?.teamKey === (selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : null);
    const hasValidStream = startStreamState?.isGeneratingResult && isStreamForCurrentTeam;

    if (hasValidData || hasValidStream) {
      handlePartnerSelectAndOpenDrawer(selectedPartner);
      return;
    }

    // if (!isSuperAnalysisComplete && hasLoadingStarted && !commonLeagueDataFailed) {
    //   console.log("Start/Sit analysis is not ready yet.");
    //   return;
    // }

    // If data is not valid or not available, fetch it on demand
    if (!hasValidData && selectedTeamInfo && !loadingStart) {
      if (setThoughtsCommon) {
        setThoughtsCommon("Loading...");
      }
      const execute = async () => {
        const { platformId, leagueId, teamName } = selectedTeamInfo;
        const currentUserDataPlatform = userDataCache[platformId];

        // Get valid token if needed (for Yahoo)
        let validToken = currentUserDataPlatform?.token;
        if (currentUserDataPlatform?.integration_name === "yahoo") {
          try {
            const yahooTokenRefreshed = await getValidYahooToken();
            if (yahooTokenRefreshed) {
              validToken = yahooTokenRefreshed;
            } else {
              console.error("Failed to get valid Yahoo token for start");
              return;
            }
          } catch (error) {
            console.error("Error getting valid Yahoo token for start:", error);
            return;
          }
        }

        // Create new controller and register it
        const controller = new AbortController();
        setCurrentAbortController(controller);
        setLoadingStart(true);
        setEndpointErrors((prev) => ({ ...prev, [`start-${platformId}-${leagueId}`]: false }));

        // Execute the endpoint with error handling (matching TeamsDropdown.tsx pattern)
        fetchStartDataStream(leagueId, platformId, teamName, controller.signal, validToken, forceRefresh, calculatorSettings, modelToUse).catch((error) => {
          if (error.name === "AbortError") throw error;
          if (!returnedFromBackground) {
            const errorMessage = error?.message || "";
            setErrorMessages((prev) => ({ ...prev, Start: errorMessage }));
            if (errorMessage.trim() !== noDraftErrorMessage) {
              const errorKey = `start-${platformId}-${leagueId}`;
              setEndpointErrors((prev) => ({ ...prev, [errorKey]: true }));
            }
          }
        });
      };

      if (modelToUse === "RotoGPT FREE") {
        // CRITICAL: Reset progress to 0 BEFORE showing ad
        // This prevents the loader from jumping to 100% when ad closes
        setStreamProgressTargets((prev) => ({ ...prev, start: 0 }));
        void gateFreeModelExecution(() => void execute());
        return;
      }

      await execute();
    }
  };

  // Click handler for Trades Button
  const handleTradesButtonClick = async () => {
    if (!showTrades) return;
    handleUnlockAudio(); // Unlock audio on this user interaction
    handleButtonSelected("trades");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Click handler for Rosters Button (new)
  const handleRostersButtonClick = async () => {
    if (!showRosters) return;
    // No audio unlock needed for Rosters
    handleButtonSelected("rosters");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Click handler for News Button
  const handleNewsButtonClick = async () => {
    if (!showNews) return;
    handleButtonSelected("news");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Click handler for Rankings Button
  const handleRankingsButtonClick = async () => {
    handleButtonSelected("rankings");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Click handler for All Rankings Button
  const handleAllRankingsButtonClick = async () => {
    if (!showAllRankings) return;
    handleButtonSelected("allRankings");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Click handler for Articles Button (no backend fetch; same pattern as chatbot endpoint_accessed)
  const handleArticlesButtonClick = async () => {
    if (!showArticles) return;
    handleUnlockAudio();
    const platformId = selectedTeamInfo?.platformId ?? "unknown";
    const leagueId = selectedTeamInfo?.leagueId ?? "unknown";
    const teamName = selectedTeamInfo?.teamName ?? "unknown";
    void trackEndpointAccess(authId ?? "unknown", platformId, leagueId, teamName, "articles");
    handleButtonSelected("articles");
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  const handleChatBotButtonClick = async () => {
    if (!showChatBot) return;
    handleUnlockAudio();

    // Chatbot costs 1 credit per response → gate when credits === 0
    // Free users → bench drawer (same pattern as other endpoints)
    // if (freeCredits === 0 && subscriptionIsFree) {
    //   console.log("[ChatBot] Opening BenchDrawer: No free credits");
    //   setIsBenchDrawerOpen(true);
    //   return;
    // }
    // // Premium users → paywall
    // if (enableCreditValidation && credits === 0 && !subscriptionIsFree) {
    //   setInitialPaymentView("manageMembership");
    //   setIsPaymentOpen(true);
    //   return;
    // }

    // Track chatbot drawer open (no backend fetch; same pattern as endpoint_accessed for other features)
    const platformId = selectedTeamInfo?.platformId ?? "unknown";
    const leagueId = selectedTeamInfo?.leagueId ?? "unknown";
    const teamName = selectedTeamInfo?.teamName ?? "unknown";
    void trackEndpointAccess(authId ?? "unknown", platformId, leagueId, teamName, "chatbot");
    console.log('tracked chatbot endpoint access for', authId, platformId, leagueId, teamName);

    handleButtonSelected("chatbot");

    // Open the drawer
    handlePartnerSelectAndOpenDrawer(selectedPartner);
  };

  // Error keys for the endpoints for retry logic
  const rundownErrorKey = selectedTeamInfo ? `rundown-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const startErrorKey = selectedTeamInfo ? `start-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const rostersErrorKey = selectedTeamInfo ? `rosters-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const newsErrorKey = selectedTeamInfo ? `news-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const rankingsErrorKey = selectedTeamInfo ? `rankings-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const allRankingsErrorKey = selectedTeamInfo ? `allRankings-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const waiverErrorKey = selectedTeamInfo ? `waiver-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";
  const DraftAdviceErrorKey = selectedTeamInfo ? `DraftAdvice-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "";

  // A permanent error is one that should not be retried.
  // This includes the global "common data failed" and the specific "no draft" error.
  // Check specific error for each endpoint
  const isPermanentErrorWaiver = commonLeagueDataFailed || errorMessageNoDraft?.waiver;
  const isPermanentErrorStart = commonLeagueDataFailed || errorMessageNoDraft?.start;
  const isPermanentErrorRundown = commonLeagueDataFailed || errorMessageNoDraft?.rundown;
  const isPermanentErrorDraftAdvice = commonLeagueDataFailed || errorMessageNoDraft?.DraftAdvice;

  const teamKey = selectedTeamInfo ? `${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}` : "no-team";

  // if the selected team is an IDP league, not show the sections buttons
  if (isIdpLeagueBlocked) {
    return null;
  }

  return (
    <>
      <FreeModelGateDrawer />
      <Grid item xs={12} sx={{ pb: 0 }}>
        <Typography variant="h5" component="h2" sx={{ color: "white", textAlign: "center", fontWeight: "bold", fontSize: "12px" }}>
          {/* FREE */}
        </Typography>
      </Grid>
      {/* ChatBot Button - Using ChatBotButton with Trades behavior */}
      <Grid item md={12} sm={12} xs={6}>
        <ChatBotButton
          key={`chatbot-${teamKey}`}
          icon={ChatIcon}
          // icon={<VoiceChatIcon />}
          // icon={<ChatIcon viewBox="-2 -10 26 32" />}
          label="Chatbot"
          isLoadingRosters={loadingRoster}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleChatBotButtonClick}
          selectedPartner={selectedPartner}
          rostersData={rostersData}
          hasError={false}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          // Show 'Analyzing...' while super analysis runs (synced leagues only; Un-Synced uses league_integration context).
          isAnalysisPending={isUnsyncedSelected ? false : !isSuperAnalysisComplete}
          // ChatBot: readiness is tied to super analysis only (not roster loading — rosters are for Trades).
          isReadyForManualTrigger={isUnsyncedSelected ? true : isSuperAnalysisComplete}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          isCreditsAnimating={isCreditsAnimating}
          creditsBoxRef={creditsBoxRef}
          userSubscription={userSubscription}
          endpointEnabled={showChatBot}
          requiresSyncedLeague={requiresSyncedLeagueFor("Chatbot")}
        />
        {showPartnerList && selectedButton === "chatbot" && <ChatBotList onClose={handlePartnerSelectAndCloseDrawer} setShouldPlayAudio={setShouldPlayAudio} autoStartRecording updateCreditsAfterEndpoint={updateCreditsAfterEndpoint} setIsBenchDrawerOpen={setIsBenchDrawerOpen} setIsPaymentOpen={setIsPaymentOpen} setInitialPaymentView={setInitialPaymentView} userSubscription={userSubscription} isCreditsAnimating={isCreditsAnimating} creditsBoxRef={creditsBoxRef}
        />}
      </Grid>

      {/* Rankings section */}
      {/* <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          icon={rankingsIcon}
          label="Rankings"
          isLoadingRankings={loadingRankings}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleRankingsButtonClick}
          selectedPartner={selectedPartner}
          rankingsData={rankingsData}
          hasError={!!endpointErrors[rankingsErrorKey]}
          errorMessage={errorMessages.Rankings}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.rankings}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingRankings(true);
            setEndpointErrors((prev) => ({ ...prev, [rankingsErrorKey]: false }));
            fetchRankingsData(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken).finally(() =>
              setLoadingRankings(false)
            );
          }}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
        />
        {showPartnerList && selectedButton === "rankings" && (
          <RankingsPartnerList onClose={handlePartnerSelectAndCloseDrawer} rankingsData={rankingsData} loadingRankings={loadingRankings} />
        )}
      </Grid> */}

      {/* All Rankings section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          icon={rankingsIcon}
          label="Rankings"
          isLoadingAllRankings={loadingAllRankings}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleAllRankingsButtonClick}
          selectedPartner={selectedPartner}
          allRankingsData={allRankingsData}
          hasError={!!endpointErrors[allRankingsErrorKey]}
          errorMessage={errorMessages.AllRankings}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.allRankings}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingAllRankings(true);
            setEndpointErrors((prev) => ({ ...prev, [allRankingsErrorKey]: false }));
            fetchAllRankingsData(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken).finally(() =>
              setLoadingAllRankings(false)
            );
          }}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showAllRankings}
          requiresSyncedLeague={requiresSyncedLeagueFor("Rankings")}
        />
        {showPartnerList && selectedButton === "allRankings" && (
          <AllRankingsPartnerList
            onClose={handlePartnerSelectAndCloseDrawer}
            allRankingsData={allRankingsData}
            loadingAllRankings={loadingAllRankings}
          />
        )}
      </Grid>

      {/* Rosters section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          // icon={<GroupsIcon viewBox="-2 -2 28 25" />}
          // icon={<GroupsIcon viewBox="-1 0 26 25" />}
          icon={rostersIcon}
          label="Rosters"
          isLoadingRosters={loadingRoster}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleRostersButtonClick}
          selectedPartner={selectedPartner}
          rostersData={rostersData}
          hasError={!!endpointErrors[rostersErrorKey]}
          errorMessage={errorMessages.Rosters}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.rosters}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingRoster(true);
            setEndpointErrors((prev) => ({ ...prev, [rostersErrorKey]: false }));
            fetchRostersData(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken).finally(() =>
              setLoadingRoster(false)
            );
          }}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showRosters}
          requiresSyncedLeague={requiresSyncedLeagueFor("Rosters")}
        />

        {showPartnerList && selectedButton === "rosters" && (
          <RostersPartnerList onClose={handlePartnerSelectAndCloseDrawer} rostersData={rostersData} loadingRoster={loadingRoster} />
        )}
      </Grid>

      {/* <Grid item xs={12} >
        <Typography variant="h5" component="h2" sx={{ color: "white", textAlign: "center", fontWeight: "bold", fontSize: "12px" }}>
          PREMIUM
        </Typography>
      </Grid> */}

      {/* Trades section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          icon={tradeIcon}
          label="Trades"
          isLoadingRosters={loadingRoster}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleTradesButtonClick}
          selectedPartner={selectedPartner}
          rostersData={rostersData}
          hasError={!!endpointErrors[rostersErrorKey]}
          errorMessage={errorMessages.Rosters}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.rosters}
          // Show 'Analyzing...' strictly while super analysis is still running
          isAnalysisPending={!isSuperAnalysisComplete}
          isReadyForManualTrigger={isSuperAnalysisComplete && !loadingRoster && !endpointErrors[rostersErrorKey]}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingRoster(true);
            setEndpointErrors((prev) => ({ ...prev, [rostersErrorKey]: false }));
            fetchRostersData(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken).finally(() =>
              setLoadingRoster(false)
            );
          }}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showTrades}
          requiresSyncedLeague={requiresSyncedLeagueFor("Trades")}
        />

        {showPartnerList && selectedButton === "trades" && (
          <TradingPartnerList
            onClose={handlePartnerSelectAndCloseDrawer}
            userDataPlatform={userDataPlatform}
            leagueIdPlatform={leagueIdPlatform}
            rostersData={rostersData}
            loadingRoster={loadingRoster}
            setErrorMessages={setErrorMessages}
            setShouldPlayAudio={setShouldPlayAudio}
            aiSettings={aiSettings}
            setIsPaymentOpen={setIsPaymentOpen}
            setInitialPaymentView={setInitialPaymentView}
            setIsBenchDrawerOpen={setIsBenchDrawerOpen}
            enableCreditValidation={enableCreditValidation}
            calculatorSettings={calculatorSettings}
            selectedModel={selectedModel}
            setSelectedModel={setSelectedModel}
            userSubscription={userSubscription}
            setUserSubscription={setUserSubscription}
            characterRef={characterRef}
            leagueSelectorBoxRef={leagueSelectorBoxRef}
            setThoughtsCommon={setThoughtsCommon}
            markSignThoughtsForDrawer={markSignThoughtsForDrawer}
            clearSignThoughtsDrawerSource={clearSignThoughtsDrawerSource}
            isCreditsAnimating={isCreditsAnimating}
            creditsBoxRef={creditsBoxRef}
          />
        )}
      </Grid>

      {/* Rundown section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        {/* {isDataValidForDisplay(rundownData) ||
        rundownData?.fromCache === true ||
        !isSuperAnalysisComplete ||
        isPermanentErrorRundown ||
        isPollingActive("rundown") ||
        loadingRundown ? ( */}
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          key={`rundown-${teamKey}`}
          icon={rundownIcon}
          label="Team Analysis"
          isLoadingRundown={loadingRundown}
          manualProgressTarget={isRundownPolling ? undefined : streamProgressTargets.rundown}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleRundownButtonClick}
          selectedPartner={selectedPartner}
          rundownData={rundownData}
          rundownStreamState={rundownStreamState}
          hasError={!!endpointErrors[rundownErrorKey]}
          errorMessage={errorMessages.Rundown}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.rundown}
          // Show 'Analyzing...' strictly while super analysis is still running
          isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(rundownData)}
          isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(rundownData) && !loadingRundown && !endpointErrors[rundownErrorKey]}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // NEW: Clear the specific lock for this endpoint before retry
            const requestKey = `${authId}-rundown-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
            activeStreamRequests.current.delete(requestKey);

            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingRundown(true);
            setEndpointErrors((prev) => ({ ...prev, [rundownErrorKey]: false }));
            // fetchRundownData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingRundown(false));
            // If FREE, require ad before retry execution (same gate as initial click)
            if (subscriptionModel === "RotoGPT FREE") {
              void gateFreeModelExecution(() => {
                fetchRundownDataStream(
                  selectedTeamInfo.leagueId,
                  selectedTeamInfo.platformId,
                  selectedTeamInfo.teamName,
                  controller.signal,
                  yahooToken,
                  forceRefresh,
                  calculatorSettings,
                  subscriptionModel
                );
              });
              return;
            }

            fetchRundownDataStream(
              selectedTeamInfo.leagueId,
              selectedTeamInfo.platformId,
              selectedTeamInfo.teamName,
              controller.signal,
              yahooToken,
              forceRefresh,
              calculatorSettings,
              subscriptionModel
            );
          }}
          isStreamActive={rundownStreamState.isStreamActive}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showTeamAnalysis}
          requiresSyncedLeague={requiresSyncedLeagueFor("Team Analysis")}
        />
        {/* ) : (
          <> */}
        {/*
            <CreditOptionButton
              key={`rundown-${teamKey}`}
              icon={rundownIcon}
              label="Team Analysis"
              isLoadingRundown={loadingRundown}
              manualProgressTarget={isRundownPolling ? undefined : streamProgressTargets.rundown}
              hasLoadingStarted={hasLoadingStarted}
              onClick={handleRundownButtonClick}
              selectedPartner={selectedPartner}
              rundownData={rundownData}
              rundownStreamState={rundownStreamState}
              hasError={!!endpointErrors[rundownErrorKey]}
              errorMessage={errorMessages.Rundown}
              commonLeagueDataFailed={commonLeagueDataFailed}
              returnedFromBackground={returnedFromBackground}
              errorMessageNoDraft={errorMessageNoDraft.rundown}
              // Show 'Analyzing...' strictly while super analysis is still running
              isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(rundownData)}
              isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(rundownData) && !loadingRundown && !endpointErrors[rundownErrorKey]}
              onRetry={() => {
                if (!selectedTeamInfo) return;
                // Cancel all pending requests
                cancelPendingRequests();
                // NEW: Clear the specific lock for this endpoint before retry
                const requestKey = `${authId}-rundown-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
                activeStreamRequests.current.delete(requestKey);

                // Create new controller and register it
                const controller = new AbortController();
                setCurrentAbortController(controller);
                setLoadingRundown(true);
                setEndpointErrors((prev) => ({ ...prev, [rundownErrorKey]: false }));
                // fetchRundownData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingRundown(false));
                fetchRundownDataStream(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken);
              }}
              isStreamActive={rundownStreamState.isStreamActive}
              selectedTeamInfo={selectedTeamInfo}
              estimatedTimes={estimatedTimes}
              getCreditsBoxPosition={getCreditsBoxPosition}
              selectedModel={selectedModel}
              setSelectedModel={setSelectedModel}
            />
            */}
        {/* </>
        )} */}
        {showPartnerList && selectedButton === "rundown" && (
          <RundownPartnerListStream
            onClose={handlePartnerSelectAndCloseDrawer}
            // rundownData={rundownData}
            rundownData={isDataValidForDisplay(rundownData) ? rundownData : undefined}
            loadingRundown={loadingRundown}
            setShouldPlayAudio={setShouldPlayAudio}
            streamStatus={rundownStreamState.status}
            streamThought={rundownStreamState.thought}
            isGeneratingResult={rundownStreamState.isGeneratingResult}
            hasRundownAnimationCompleted={hasRundownAnimationCompleted}
            setHasRundownAnimationCompleted={setHasRundownAnimationCompleted}
            streamProgress={streamProgress}
            setStreamProgress={setStreamProgress}
            isWaitingForChart={rundownStreamState.isWaitingForChart}
            // isWaitingForAudio={rundownStreamState.isGeneratingAudio}
            rundownAudio={summaryAudios.rundown}
            rundownAudioRef={summaryAudioRefs.rundown}
            // isRundownAudioPlaying={isRundownAudioPlaying}
            // onToggleRundownAudio={onToggleRundownAudio}
            isRecoveringFromBackground={isRecoveringFromBackground.rundown}
            selectedButton={selectedButton}
            setIsPaymentOpen={setIsPaymentOpen}
            setInitialPaymentView={setInitialPaymentView}
            leagueSelectorBoxRef={leagueSelectorBoxRef}
          />
        )}
      </Grid>


      {/* Start section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        {/* {isDataValidForDisplay(startData) || startData?.fromCache === true || !isSuperAnalysisComplete || isPermanentErrorStart || isPollingActive("start") || loadingStart ? ( */}
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          key={`start-${teamKey}`}
          icon={startIcon}
          label="Start/Sit"
          isLoadingStart={loadingStart}
          manualProgressTarget={isStartPolling ? undefined : streamProgressTargets.start}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleStartButtonClick}
          selectedPartner={selectedPartner}
          startData={startData}
          startStreamState={startStreamState}
          hasError={!!endpointErrors[startErrorKey]}
          errorMessage={errorMessages.Start}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.start}
          // Show 'Analyzing...' strictly while super analysis is still running
          isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(startData)}
          isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(startData) && !loadingStart && !endpointErrors[startErrorKey]}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // NEW: Clear the specific lock for this endpoint before retry
            const requestKey = `${authId}-start-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
            console.log("Request key FOR START SECTION HOME:", requestKey);

            activeStreamRequests.current.delete(requestKey);

            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingStart(true);
            setEndpointErrors((prev) => ({ ...prev, [startErrorKey]: false }));
            // fetchStartData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingStart(false));
            // If FREE, require ad before retry execution (same gate as initial click)
            if (subscriptionModel === "RotoGPT FREE") {
              void gateFreeModelExecution(() => {
                fetchStartDataStream(
                  selectedTeamInfo.leagueId,
                  selectedTeamInfo.platformId,
                  selectedTeamInfo.teamName,
                  controller.signal,
                  yahooToken,
                  forceRefresh,
                  calculatorSettings,
                  subscriptionModel
                );
              });
              return;
            }

            fetchStartDataStream(
              selectedTeamInfo.leagueId,
              selectedTeamInfo.platformId,
              selectedTeamInfo.teamName,
              controller.signal,
              yahooToken,
              forceRefresh,
              calculatorSettings,
              subscriptionModel
            );
          }}
          isStreamActive={startStreamState.isStreamActive}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showStart}
          requiresSyncedLeague={requiresSyncedLeagueFor("Start/Sit")}
        />
        {/* ) : (
          <> */}
        {/*
            <CreditOptionButton
              key={`start-${teamKey}`}
              icon={startIcon}
              label="Start/Sit"
              isLoadingStart={loadingStart}
              manualProgressTarget={isStartPolling ? undefined : streamProgressTargets.start}
              hasLoadingStarted={hasLoadingStarted}
              onClick={handleStartButtonClick}
              selectedPartner={selectedPartner}
              startData={startData}
              startStreamState={startStreamState}
              hasError={!!endpointErrors[startErrorKey]} // if the error of this key is true, hasError will be true. If the error of this key is undefined ({}), hasError will be false for the !!.
              errorMessage={errorMessages.Start}
              commonLeagueDataFailed={commonLeagueDataFailed}
              returnedFromBackground={returnedFromBackground}
              errorMessageNoDraft={errorMessageNoDraft.start}
              // Show 'Analyzing...' strictly while super analysis is still running
              isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(startData)}
              isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(startData) && !loadingStart && !endpointErrors[startErrorKey]}
              onRetry={() => {
                if (!selectedTeamInfo) return;
                // Cancel all pending requests
                cancelPendingRequests();
                // NEW: Clear the specific lock for this endpoint before retry
                const requestKey = `${authId}-start-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
                activeStreamRequests.current.delete(requestKey);

                // Create new controller and register it
                const controller = new AbortController();
                setCurrentAbortController(controller);
                setLoadingStart(true);
                setEndpointErrors((prev) => ({ ...prev, [startErrorKey]: false }));
                // fetchStartData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingStart(false));
                fetchStartDataStream(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken);
              }}
              isStreamActive={startStreamState.isStreamActive}
              selectedTeamInfo={selectedTeamInfo}
              estimatedTimes={estimatedTimes}
              getCreditsBoxPosition={getCreditsBoxPosition}
              selectedModel={selectedModel}
              setSelectedModel={setSelectedModel}
            />
            */}
        {/* </>
        )} */}
        {showPartnerList && selectedButton === "start" && (
          <StartPartnerListStream
            onClose={handlePartnerSelectAndCloseDrawer}
            // startData={startData}
            startData={isDataValidForDisplay(startData) ? startData : undefined}
            loadingStart={loadingStart}
            setShouldPlayAudio={setShouldPlayAudio}
            streamStatus={startStreamState.status}
            streamThought={startStreamState.thought}
            isGeneratingResult={startStreamState.isGeneratingResult}
            hasStartAnimationCompleted={hasStartAnimationCompleted}
            setHasStartAnimationCompleted={setHasStartAnimationCompleted}
            streamProgress={streamProgress}
            setStreamProgress={setStreamProgress}
            isWaitingForChart={startStreamState.isWaitingForChart}
            // isWaitingForAudio={startStreamState.isGeneratingAudio}
            startAudioRef={summaryAudioRefs.start}
            isRecoveringFromBackground={isRecoveringFromBackground.start}
            selectedButton={selectedButton}
            setIsPaymentOpen={setIsPaymentOpen}
            setInitialPaymentView={setInitialPaymentView}
            leagueSelectorBoxRef={leagueSelectorBoxRef}
          // startAudio={summaryAudios.start}
          />
        )}
      </Grid>

      {/* Waiver section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        {/* {isDataValidForDisplay(waiverData) || waiverData?.fromCache === true || !isSuperAnalysisComplete || isPermanentErrorWaiver || isPollingActive("waiver") || loadingWaiver ? ( */}
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          key={`waivers-${teamKey}`}
          icon={waiverIcon}
          label="Waivers"
          isLoadingWaiver={loadingWaiver}
          manualProgressTarget={isWaiverPolling ? undefined : streamProgressTargets.waiver}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleWaiverButtonClick}
          selectedPartner={selectedPartner}
          waiverData={waiverData}
          waiverStreamState={waiverStreamState}
          hasError={!!endpointErrors[waiverErrorKey]}
          errorMessage={errorMessages.Waiver}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.waiver}
          // Show 'Analyzing...' strictly while super analysis is still running
          isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(waiverData)}
          isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(waiverData) && !loadingWaiver && !endpointErrors[waiverErrorKey]}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // NEW: Clear the specific lock for this endpoint before retry
            const requestKey = `${authId}-waiver-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
            console.log("Request key FOR WAIVER SECTION HOME:", requestKey);

            activeStreamRequests.current.delete(requestKey);

            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingWaiver(true);
            setEndpointErrors((prev) => ({ ...prev, [waiverErrorKey]: false }));
            // fetchWaiverData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingWaiver(false));
            // If FREE, require ad before retry execution (same gate as initial click)
            if (subscriptionModel === "RotoGPT FREE") {
              void gateFreeModelExecution(() => {
                fetchWaiverDataStream(
                  selectedTeamInfo.leagueId,
                  selectedTeamInfo.platformId,
                  selectedTeamInfo.teamName,
                  controller.signal,
                  yahooToken,
                  forceRefresh,
                  calculatorSettings,
                  subscriptionModel
                );
              });
              return;
            }

            fetchWaiverDataStream(
              selectedTeamInfo.leagueId,
              selectedTeamInfo.platformId,
              selectedTeamInfo.teamName,
              controller.signal,
              yahooToken,
              forceRefresh,
              calculatorSettings,
              subscriptionModel
            );
          }}
          isStreamActive={waiverStreamState.isStreamActive}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showWaiver}
          requiresSyncedLeague={requiresSyncedLeagueFor("Waivers")}
        />
        {/* ) : (
          <> */}

        {/*
            <CreditOptionButton
              key={`waivers-${teamKey}`}
              icon={waiverIcon}
              label="Waivers"
              isLoadingWaiver={loadingWaiver}
              manualProgressTarget={isWaiverPolling ? undefined : streamProgressTargets.waiver}
              hasLoadingStarted={hasLoadingStarted}
              onClick={handleWaiverButtonClick}
              selectedPartner={selectedPartner}
              waiverData={waiverData}
              waiverStreamState={waiverStreamState}
              hasError={!!endpointErrors[waiverErrorKey]}
              errorMessage={errorMessages.Waiver}
              commonLeagueDataFailed={commonLeagueDataFailed}
              returnedFromBackground={returnedFromBackground}
              errorMessageNoDraft={errorMessageNoDraft.waiver}
              // Show 'Analyzing...' strictly while super analysis is still running
              isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(waiverData)}
              isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(waiverData) && !loadingWaiver && !endpointErrors[waiverErrorKey]}
              onRetry={() => {
                if (!selectedTeamInfo) return;
                // Cancel all pending requests
                cancelPendingRequests();
                // NEW: Clear the specific lock for this endpoint before retry
                const requestKey = `${authId}-waiver-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
                console.log("Request key FOR WAIVER SECTION HOME:", requestKey);

                activeStreamRequests.current.delete(requestKey);

                // Create new controller and register it
                const controller = new AbortController();
                setCurrentAbortController(controller);
                setLoadingWaiver(true);
                setEndpointErrors((prev) => ({ ...prev, [waiverErrorKey]: false }));
                // fetchWaiverData(selectedTeamInfo.leagueId, controller.signal, yahooToken).finally(() => setLoadingWaiver(false));
                fetchWaiverDataStream(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken);
              }}
              isStreamActive={waiverStreamState.isStreamActive}
              selectedTeamInfo={selectedTeamInfo}
              estimatedTimes={estimatedTimes}
              getCreditsBoxPosition={getCreditsBoxPosition}
              selectedModel={selectedModel}
              setSelectedModel={setSelectedModel}
            />
            */}
        {/* </>
        )} */}
        {showPartnerList && selectedButton === "waiver" && (
          <WaiverPartnerListStream
            onClose={handlePartnerSelectAndCloseDrawer}
            // waiverData={waiverData}
            waiverData={isDataValidForDisplay(waiverData) ? waiverData : undefined}
            loadingWaiver={loadingWaiver}
            setShouldPlayAudio={setShouldPlayAudio}
            streamStatus={waiverStreamState.status}
            streamThought={waiverStreamState.thought}
            isGeneratingResult={waiverStreamState.isGeneratingResult}
            hasWaiverAnimationCompleted={hasWaiverAnimationCompleted}
            setHasWaiverAnimationCompleted={setHasWaiverAnimationCompleted}
            streamProgress={streamProgress}
            setStreamProgress={setStreamProgress}
            isWaitingForChart={waiverStreamState.isWaitingForChart}
            isRecoveringFromBackground={isRecoveringFromBackground.waiver}
            selectedButton={selectedButton}
            // isWaitingForAudio={waiverStreamState.isGeneratingAudio}
            // waiverAudio={summaryAudios.waiver}
            waiverAudioRef={summaryAudioRefs.waiver}
            setIsPaymentOpen={setIsPaymentOpen}
            setInitialPaymentView={setInitialPaymentView}
            leagueSelectorBoxRef={leagueSelectorBoxRef}
            isCreditsAnimating={isCreditsAnimating}
            creditsBoxRef={creditsBoxRef}
            userSubscription={userSubscription}

          />
        )}
      </Grid>

      {/* Draft Advice section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          key={`DraftAdvice-${teamKey}`}
          icon={DraftAdviceIcon3}
          // icon={rundownIcon}
          label="Draft Advice"
          isLoadingDraftAdvice={loadingDraftAdvice}
          manualProgressTarget={isDraftAdvicePolling ? undefined : streamProgressTargets.DraftAdvice}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleDraftAdviceButtonClick}
          selectedPartner={selectedPartner}
          DraftAdviceData={DraftAdviceData}
          DraftAdviceStreamState={DraftAdviceStreamState}
          hasError={!!endpointErrors[DraftAdviceErrorKey]}
          errorMessage={errorMessages.DraftAdvice}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.DraftAdvice}
          isAnalysisPending={!isSuperAnalysisComplete && !isDataValidForDisplay(DraftAdviceData)}
          isReadyForManualTrigger={isSuperAnalysisComplete && !isDataValidForDisplay(DraftAdviceData) && !loadingDraftAdvice && !endpointErrors[DraftAdviceErrorKey]}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            cancelPendingRequests();
            const requestKey = `${authId}-DraftAdvice-${selectedTeamInfo.platformId}-${selectedTeamInfo.leagueId}`;
            activeStreamRequests.current.delete(requestKey);
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingDraftAdvice(true);
            setEndpointErrors((prev) => ({ ...prev, [DraftAdviceErrorKey]: false }));
            if (subscriptionModel === "RotoGPT FREE") {
              void gateFreeModelExecution(() => {
                fetchDraftAdviceDataStream(
                  selectedTeamInfo.leagueId,
                  selectedTeamInfo.platformId,
                  selectedTeamInfo.teamName,
                  controller.signal,
                  yahooToken,
                  forceRefresh,
                  calculatorSettings,
                  subscriptionModel
                );
              });
              return;
            }
            fetchDraftAdviceDataStream(
              selectedTeamInfo.leagueId,
              selectedTeamInfo.platformId,
              selectedTeamInfo.teamName,
              controller.signal,
              yahooToken,
              forceRefresh,
              calculatorSettings,
              subscriptionModel
            );
          }}
          isStreamActive={DraftAdviceStreamState.isStreamActive}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          // endpointEnabled={draftAdviceEndpointEnabled && !isLeagueTypeRedraft} // if showDraftAdvice is true and isLeagueTypeRedraft is false, then the endpoint is enabled
          endpointEnabled={draftAdviceEnabledForSelectedLeague}
          requiresSyncedLeague={requiresSyncedLeagueFor("Draft Advice")}
        />

        {showPartnerList && selectedButton === "DraftAdvice" && (
          <DraftAdvicePartnerListStream
            onClose={handlePartnerSelectAndCloseDrawer}
            DraftAdviceData={isDataValidForDisplay(DraftAdviceData) ? DraftAdviceData : undefined}
            loadingDraftAdvice={loadingDraftAdvice}
            setShouldPlayAudio={setShouldPlayAudio}
            streamStatus={DraftAdviceStreamState.status}
            streamThought={DraftAdviceStreamState.thought}
            isGeneratingResult={DraftAdviceStreamState.isGeneratingResult}
            hasDraftAdviceAnimationCompleted={hasDraftAdviceAnimationCompleted}
            setHasDraftAdviceAnimationCompleted={setHasDraftAdviceAnimationCompleted}
            streamProgress={streamProgress}
            setStreamProgress={setStreamProgress}
            isWaitingForChart={DraftAdviceStreamState.isWaitingForChart}
            DraftAdviceAudio={summaryAudios.DraftAdvice}
            DraftAdviceAudioRef={summaryAudioRefs.DraftAdvice}
            isRecoveringFromBackground={isRecoveringFromBackground.DraftAdvice}
            selectedButton={selectedButton}
            setIsPaymentOpen={setIsPaymentOpen}
            setInitialPaymentView={setInitialPaymentView}
            leagueSelectorBoxRef={leagueSelectorBoxRef}
            onRefreshDraftAdvice={handleDraftAdviceForcedRefresh}
            isRefreshingDraftAdvice={loadingDraftAdvice}
            isCreditsAnimating={isCreditsAnimating}
            creditsBoxRef={creditsBoxRef}
            showDraftAdviceFooterLoader={showDraftAdviceFooterLoader}
          />
        )}
      </Grid>

      {/* News section */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          icon={newsIcon}
          label="News"
          isLoadingNews={loadingNews}
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleNewsButtonClick}
          selectedPartner={selectedPartner}
          newsData={newsData}
          hasError={!!endpointErrors[newsErrorKey]}
          errorMessage={errorMessages.News}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          errorMessageNoDraft={errorMessageNoDraft.news}
          onRetry={() => {
            if (!selectedTeamInfo) return;
            // Cancel all pending requests
            cancelPendingRequests();
            // Create new controller and register it
            const controller = new AbortController();
            setCurrentAbortController(controller);
            setLoadingNews(true);
            setEndpointErrors((prev) => ({ ...prev, [newsErrorKey]: false }));
            fetchNewsData(selectedTeamInfo.leagueId, selectedTeamInfo.platformId, selectedTeamInfo.teamName, controller.signal, yahooToken).finally(() => setLoadingNews(false));
          }}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          endpointEnabled={showNews}
          requiresSyncedLeague={requiresSyncedLeagueFor("News")}
        />
        {showPartnerList && selectedButton === "news" && <NewsPartnerList onClose={handlePartnerSelectAndCloseDrawer} newsData={newsData} loadingNews={loadingNews} />}
      </Grid>


      {/* Articles (CMS): published-only list + detail in the same drawer */}
      <Grid item zeroMinWidth md={4} sm={4} xs={6} sx={{ pb: 2 }}>
        <AnimatedButton
          isStartupMode={isStartupMode}
          isDraftOrderSetExplicitlyFalse={isDraftOrderSetExplicitlyFalse}
          isDraftOrderSet={isDraftOrderSet}
          leagueStatus={leagueStatus}
          isUserHasDraftedPlayers={isUserHasDraftedPlayers}
          commonLeagueDataReadyForDraftOrder={commonLeagueDataReadyForDraftOrder}
          isLeagueTypeRedraft={isLeagueTypeRedraft}
          icon={<ArticleIcon sx={{ fontSize: 44 }} />}
          label="Articles"
          hasLoadingStarted={hasLoadingStarted}
          onClick={handleArticlesButtonClick}
          selectedPartner={selectedPartner}
          hasError={false}
          commonLeagueDataFailed={commonLeagueDataFailed}
          returnedFromBackground={returnedFromBackground}
          selectedTeamInfo={selectedTeamInfo}
          estimatedTimes={estimatedTimes}
          isAnalysisPending={false}
          isReadyForManualTrigger={!!selectedTeamInfo}
          endpointEnabled={showArticles}
          requiresSyncedLeague={requiresSyncedLeagueFor("Articles")}
        />
        {showPartnerList && selectedButton === "articles" && (
          <ArticlesPartnerList onClose={handlePartnerSelectAndCloseDrawer} />
        )}
      </Grid>

    </>
  );
};

export default SectionHomePage;
